var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paperclip 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.2937 3.27344C14.3419 2.32031 12.7971 2.32031 11.8452 3.27344L4.66731 10.4609C3.02497 12.1055 3.02497 14.7695 4.66731 16.4141C6.30964 18.0586 8.97015 18.0586 10.6125 16.4141L16.5421 10.4766C16.9673 10.0508 17.6617 10.0508 18.0869 10.4766C18.5121 10.9023 18.5121 11.5977 18.0869 12.0234L12.1573 17.9609C9.66063 20.4609 5.61916 20.4609 3.1225 17.9609C0.625834 15.4609 0.625834 11.4141 3.1225 8.91406L10.3004 1.72656C12.1066 -0.0820313 15.0324 -0.0820313 16.8385 1.72656C18.6447 3.53516 18.6447 6.46484 16.8385 8.27344L9.97271 15.1484C8.85702 16.2656 7.04694 16.2656 5.93124 15.1484C4.81555 14.0312 4.81555 12.2188 5.93124 11.1016L11.5487 5.47656C11.9739 5.05078 12.6683 5.05078 13.0935 5.47656C13.5188 5.90234 13.5188 6.59766 13.0935 7.02344L7.47605 12.6484C7.21468 12.9102 7.21468 13.3398 7.47605 13.6016C7.73742 13.8633 8.16653 13.8633 8.4279 13.6016L15.2937 6.72656C16.2456 5.77344 16.2456 4.22656 15.2937 3.27344Z",
    fill: "#004BB9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpload);
export default __webpack_public_path__ + "static/media/icon-upload.d1c55658d310b33cf4f94ddbaf485051.svg";
export { ForwardRef as ReactComponent };